// extracted by mini-css-extract-plugin
module.exports = {"deniedText":"styles_deniedText__3WEbz","closeBrowser":"styles_closeBrowser__2Mf5p","warningIcon":"styles_warningIcon__16XBe"};